export const PILOTAGE_APPS = [
  { id: 'workspace', path: '/mon-espace', name: 'Mon espace de travail', shortName: 'Mon espace', description: 'Collectes, validations et dossiers de votre équipe', icon: 'workspace' },
  { id: 'dashboards', path: '/mes-tableaux', name: 'Mes tableaux de bord', shortName: 'Mes tableaux', description: 'Créer, personnaliser et partager vos tableaux', icon: 'dashboard' },
  { id: 'cockpit', path: '/cockpit', name: 'Cockpit exécutif', shortName: 'Cockpit', description: 'Synthèse institutionnelle et décisions', icon: 'gauge' },
  { id: 'board', path: '/tableau-dg', name: 'Tableau de bord DG', shortName: 'Tableau DG', description: 'Indicateurs et domaines stratégiques', icon: 'dashboard' },
  { id: 'trees', path: '/arbres-kpi', name: 'Arbres de performance', shortName: 'Arbres', description: 'Axes, contributions et KPI publiés', icon: 'network' },
  { id: 'directions', path: '/pilotage-directions', name: 'Pilotage des directions', shortName: 'Directions', description: 'Directions, départements et sections', icon: 'building' },
] as const;

export function pilotageApp(path: string) {
  return PILOTAGE_APPS.find(app => app.path === path);
}

export function rememberPilotageLocation() {
  if (!pilotageApp(location.pathname)) return;
  try { sessionStorage.setItem(`pilotage.location.${location.pathname}`, `${location.pathname}${location.search}${location.hash}`); } catch { /* Optional tab memory. */ }
}

export function pilotageDestination(path: string) {
  try {
    const saved = sessionStorage.getItem(`pilotage.location.${path}`);
    if (saved) {
      const url = new URL(saved, location.origin);
      if (url.origin === location.origin && url.pathname === path) return `${url.pathname}${url.search}${url.hash}`;
    }
  } catch { /* A direct application link remains available without storage. */ }
  return path;
}
